// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__DcPV0","signatureButtonsRight":"ModalSign_signatureButtonsRight__3ulit"};